import { type Libraries, useJsApiLoader } from '@react-google-maps/api';

const libraries: Libraries = ['places'];

export function useGoogleMapsLoader() {
	return useJsApiLoader({
		id: 'google-map-script',
		googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
		libraries,
		language: 'en',
	});
}
